module.exports = __webpack_public_path__ + "img/rolesTypes.ea74d53b.svg";